// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Formality = require("../../vendor/re-formality/Formality.bs.js");
let Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
let Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let UseNavigationStopper = require("../common/Hooks/UseNavigationStopper.bs.js");
let Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let AgentMarketingProfileAboutSettingsQuery_graphql = require("../../__generated__/AgentMarketingProfileAboutSettingsQuery_graphql.bs.js");
let AgentMarketingProfileAboutSettingsMutation_graphql = require("../../__generated__/AgentMarketingProfileAboutSettingsMutation_graphql.bs.js");
let AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.bs.js");

let convertFragment = AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = AgentMarketingProfileAboutSettingsMutation_graphql.Internal.convertVariables;

let convertResponse = AgentMarketingProfileAboutSettingsMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = AgentMarketingProfileAboutSettingsMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, AgentMarketingProfileAboutSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, AgentMarketingProfileAboutSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

let validators = {
  specialties: undefined,
  bio: undefined
};

function initialFieldsStatuses(input) {
  return {
    specialties: "Pristine",
    bio: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    specialties: "Pristine",
    bio: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      specialties: "Pristine",
      bio: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, param, param$1) {
  let match_0 = {
    TAG: "Ok",
    _0: input.specialties
  };
  let match_0$1 = {
    TAG: "Ok",
    _0: input.bio
  };
  let specialtiesResult = match_0;
  let specialtiesResult$1;
  if (specialtiesResult.TAG === "Ok") {
    let bioResult = match_0$1;
    if (bioResult.TAG === "Ok") {
      return {
        TAG: "Valid",
        output: {
          bio: bioResult._0,
          specialties: specialtiesResult._0
        },
        fieldsStatuses: {
          specialties: {
            TAG: "Dirty",
            _0: specialtiesResult,
            _1: "Hidden"
          },
          bio: {
            TAG: "Dirty",
            _0: bioResult,
            _1: "Hidden"
          }
        },
        collectionsStatuses: undefined
      };
    }
    specialtiesResult$1 = specialtiesResult;
  } else {
    specialtiesResult$1 = specialtiesResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      specialties: {
        TAG: "Dirty",
        _0: specialtiesResult$1,
        _1: "Hidden"
      },
      bio: {
        TAG: "Dirty",
        _0: match_0$1,
        _1: "Hidden"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurSpecialtiesField" :
          let result = Formality.validateFieldOnBlurWithoutValidator(state.input.specialties, state.fieldsStatuses.specialties, status => {
            let init = state.fieldsStatuses;
            return {
              specialties: status,
              bio: init.bio
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurBioField" :
          let result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.bio, state.fieldsStatuses.bio, status => {
            let init = state.fieldsStatuses;
            return {
              specialties: init.specialties,
              bio: status
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateSpecialtiesField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.specialties, status => {
                let init = state.fieldsStatuses;
                return {
                  specialties: status,
                  bio: init.bio
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateBioField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.bio, status => {
                let init = state.fieldsStatuses;
                return {
                  specialties: init.specialties,
                  bio: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  specialties: "Pristine",
                  bio: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  specialties: "Pristine",
                  bio: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateSpecialties: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateSpecialtiesField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateBio: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBioField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurSpecialties: () => dispatch("BlurSpecialtiesField"),
    blurBio: () => dispatch("BlurBioField"),
    specialtiesResult: Formality.exposeFieldResult(state.fieldsStatuses.specialties),
    bioResult: Formality.exposeFieldResult(state.fieldsStatuses.bio),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.specialties;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.bio;
      return typeof tmp$1 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function initialInputFromFragment(fragment) {
  return {
    bio: fragment.bio,
    specialties: fragment.specialties
  };
}

function AgentMarketingProfileAboutSettings$Form$RichTextField(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.labelText
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(RichTextEditorV5.make, {
            initialContent: props.initialValue,
            onChange: props.onChange,
            onBlur: props.onBlur,
            toolbar: "withSingleHeadingLevel",
            proseStyle: "md"
          }),
          Stdlib_Option.getOr(Stdlib_Option.map(props.helpText, text => JsxRuntime.jsx("div", {
            children: text,
            className: "text-base text-gray-500"
          })), null)
        ],
        className: "mt-2 sm:col-span-2 sm:mt-0 space-y-3"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let RichTextField = {
  make: AgentMarketingProfileAboutSettings$Form$RichTextField
};

function AgentMarketingProfileAboutSettings$Form$ConfirmationDialog(props) {
  let formStatus = props.formStatus;
  let onDiscard = props.onDiscard;
  let onCancel = props.onCancel;
  let onConfirm = props.onConfirm;
  let tmp;
  tmp = typeof formStatus !== "object" || formStatus.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(Alert.$$Error.make, {
      title: "There was an error updating your account. Please try again"
    });
  let tmp$1;
  tmp$1 = typeof formStatus !== "object" ? formStatus !== "Editing" : formStatus.TAG === "Submitting";
  return JsxRuntime.jsx(DialogV5.make, {
    title: "Unsaved changes",
    isOpen: props.isOpen,
    ariaLabel: "Unsaved changes",
    onDismiss: onCancel,
    size: "Large",
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: "You have unsaved changes. Do you want to save them?",
          className: "text-base text-gray-500"
        }),
        tmp,
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: param => onCancel(),
              children: "Cancel"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                  onClick: param => onDiscard(),
                  children: "Discard"
                }),
                JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                  onClick: param => onConfirm(),
                  disabled: tmp$1,
                  children: "Save"
                })
              ],
              className: "flex justify-end gap-3"
            })
          ],
          className: "flex justify-between"
        })
      ],
      className: "space-y-4"
    })
  });
}

let ConfirmationDialog = {
  make: AgentMarketingProfileAboutSettings$Form$ConfirmationDialog
};

function AgentMarketingProfileAboutSettings$Form(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(AgentMarketingProfileAboutSettings_form_agentMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  let match = use$1();
  let mutate = match[0];
  let form = useForm(initialInputFromFragment(marketingProfile), (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    mutate({
      input: {
        bio: param.bio,
        specialties: param.specialties
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let result = param.updateAgentMarketingProfileAboutSection;
      if (result !== undefined && result.__typename === "AgentMarketingProfileAboutSectionUpdated") {
        return notifyOnSuccess(undefined);
      } else {
        return notifyOnFailure();
      }
    }, param => notifyOnFailure(), undefined);
  });
  let match$1 = React.useState(() => JSON.stringify(form.input));
  let match$2 = React.useState(() => false);
  let setIsConfirmationDialogOpen = match$2[1];
  let isConfirmationDialogOpen = match$2[0];
  let navigate = UseNavigationStopper.use(match$1[0] !== JSON.stringify(form.input), () => setIsConfirmationDialogOpen(param => true));
  React.useEffect(() => {
    let match = form.status;
    if (typeof match !== "object" && match === "Submitted") {
      if (isConfirmationDialogOpen && navigate !== undefined) {
        navigate();
      }
    }
  }, [
    form.status,
    isConfirmationDialogOpen,
    navigate
  ]);
  let match$3 = form.status;
  let tmp;
  tmp = typeof match$3 !== "object" ? (
      match$3 === "Editing" ? null : JsxRuntime.jsx(Alert.Success.make, {
          title: "Your account was updated"
        })
    ) : (
      match$3.TAG === "Submitting" ? null : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Alert.$$Error.make, {
            title: "There was an error updating your account. Please try again"
          }),
          className: "mt-4"
        })
    );
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsx(AgentMarketingProfileAboutSettings$Form$ConfirmationDialog, {
        onConfirm: () => {
          if (form.valid()) {
            return form.submit();
          } else {
            return setIsConfirmationDialogOpen(param => false);
          }
        },
        isOpen: isConfirmationDialogOpen,
        onCancel: () => setIsConfirmationDialogOpen(param => false),
        onDiscard: () => {
          setIsConfirmationDialogOpen(param => false);
          form.reset();
          if (navigate !== undefined) {
            return navigate();
          }
        },
        formStatus: form.status
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(AgentMarketingProfileAboutSettings$Form$RichTextField, {
                onChange: value => form.updateBio((input, value) => ({
                  bio: value,
                  specialties: input.specialties
                }), value),
                onBlur: param => form.blurBio(),
                initialValue: marketingProfile.bio,
                labelText: "Bio"
              }),
              JsxRuntime.jsx(AgentMarketingProfileAboutSettings$Form$RichTextField, {
                onChange: value => form.updateSpecialties((input, value) => ({
                  bio: input.bio,
                  specialties: value
                }), value),
                onBlur: param => form.blurSpecialties(),
                initialValue: marketingProfile.specialties,
                labelText: "Specialties",
                helpText: "We recommend formatting your specialties as a bullet list."
              })
            ],
            className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                href: Scalars.URL.toString(marketingProfile.publicUrl),
                target: "_blank",
                children: "View Profile"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                    disabled: form.submitting,
                    children: "Save changes"
                  }),
                  JsxRuntime.jsx("div", {
                    children: tmp,
                    role: "status"
                  })
                ],
                className: "flex flex-col items-end gap-3"
              })
            ],
            className: "flex justify-between items-baseline"
          })
        ],
        className: "space-y-6"
      })
    ],
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let Form = {
  Fragment: Fragment,
  Mutation: Mutation,
  Config: Config,
  initialInputFromFragment: initialInputFromFragment,
  RichTextField: RichTextField,
  ConfirmationDialog: ConfirmationDialog,
  make: AgentMarketingProfileAboutSettings$Form
};

function AgentMarketingProfileAboutSettings$Header(props) {
  let displayName = MarketingProfileSubpages.Page.Agent.useDisplayName();
  let breadcrumbs = [
    {
      name: "Marketing Profile",
      href: "/account/marketing_profile"
    },
    {
      name: displayName("Bio"),
      href: MarketingProfileSubpages.Page.Agent.path("Bio")
    }
  ];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(Breadcrumbs.make, {
        pages: breadcrumbs
      }),
      JsxRuntime.jsx("h2", {
        children: displayName("Bio"),
        className: "text-zinc-800 text-3xl font-medium"
      })
    ],
    className: "space-y-3 border-b pb-2"
  });
}

let Header = {
  make: AgentMarketingProfileAboutSettings$Header
};

let convertVariables$1 = AgentMarketingProfileAboutSettingsQuery_graphql.Internal.convertVariables;

let convertResponse$1 = AgentMarketingProfileAboutSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = AgentMarketingProfileAboutSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$2 = RescriptRelay_Query.useQuery(convertVariables$1, AgentMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, AgentMarketingProfileAboutSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(AgentMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(AgentMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(AgentMarketingProfileAboutSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(AgentMarketingProfileAboutSettingsQuery_graphql.node, convertVariables$1);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function AgentMarketingProfileAboutSettings(props) {
  let match = use$2(undefined, undefined, undefined, undefined);
  let marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "AgentMarketingProfile") {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(AgentMarketingProfileAboutSettings$Header, {}),
          JsxRuntime.jsx(AgentMarketingProfileAboutSettings$Form, {
            marketingProfile: marketingProfile.fragmentRefs
          })
        ],
        className: "space-y-8 sm:space-y-0"
      }),
      className: "bg-white p-6 shadow-sm rounded space-y-8"
    });
  } else {
    return UnselectedUnionMemberError.raise(`Unselected union member: ` + marketingProfile._0);
  }
}

let make = AgentMarketingProfileAboutSettings;

exports.Form = Form;
exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
